var _g, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-90 0 32)",
    fill: "#D9D2FE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 4 28)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 20.5H11.976V19.506C11.976 17.77 12.662 16.902 14.594 16.244L16.834 15.474C17.954 15.068 18.346 14.69 18.346 13.864C18.346 12.87 17.702 12.366 16.022 12.366C14.146 12.366 13.446 13.024 13.446 14.256V14.424H11.962V14.284C11.962 12.548 13.152 10.98 16.078 10.98C18.738 10.98 19.858 12.24 19.858 13.892C19.858 15.432 18.864 16.244 17.212 16.748L15.238 17.35C13.978 17.784 13.544 18.232 13.544 19.296L15.812 19.142H19.83V20.5Z",
    fill: "#523FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTwo);
export default __webpack_public_path__ + "static/media/active-two.7d57f48bb631fa7ee1d2f9c022fe8671.svg";
export { ForwardRef as ReactComponent };